<ng-container *ngIf="showButton">
  <ng-container *ngIf="isLinkInternal; else external">
    <div *ngIf="url" role="button" routerLink="{{url}}" class="btn-homepage mt-4" [ngClass]="buttonClasses" [style.text-align]="buttonAlignment" [style.background]="color" [style.color]="textColor">
      {{ text }}
    </div>
    <a *ngIf="!url" role="button" [href]="'mailto:' + email" class="btn-homepage d-block mt-4" [ngClass]="buttonClasses" [style.text-align]="buttonAlignment" [style.background]="color" [style.color]="textColor" style="text-decoration: none;">
      {{ text }}
    </a>
  </ng-container>
  <ng-template #external>
    <div role="button" (click)="navigateByUrl(url)" class="btn-homepage mt-4" [ngClass]="buttonClasses" [style.text-align]="buttonAlignment" [style.background]="color" [style.color]="textColor">
      {{ text }}
    </div>
  </ng-template>
</ng-container>
